import { isPartnerSite, getLandSearchRoute } from "utils";

export default () => {
  const isWhitelabelSite = isPartnerSite();

  if (isWhitelabelSite) {
    return [
      {
        title: "home",
        url: "/",
      },
      {
        title: "Listings Type",
        open: false,
        icon: {
          type: "down",
          position: "right",
        },
        key: "lisiting-type",
        subMenu: [
          {
            title: "For Sale",
            url: "/#sale-listing",
          },
          {
            title: "Auction",
            url: "/#auction-listing",
          },
          {
            title: "Tillable leases",
            url: "/#tillable-leases",
          },
          {
            title: "Hunting Leases",
            url: "/#hunting-leases",
          },
          {
            title: "View all",
            url: getLandSearchRoute(),
          },
        ],
      },
      {
        title: "landowner",
        url: "/landowner",
      },
      {
        title: "Search By Map",
        url: getLandSearchRoute(),
      },
      {
        title: "Get a CashRentstimate",
        url: "/free-estimate?step=0&lng=-94.0189807232717&lat=35.6322974439909&zoom=5",
      },
      {
        title: "Contact us",
        url: "/contact-us",
      },
    ];
  }

  return [
    {
      title: "Farmer",
      url: "/",
    },
    {
      title: "Landowner",
      url: "/landowner",
    },
    {
      title: "Business Solutions",
      url: "https://groundos.com",
    },
    {
      title: "Search By Map",
      url: getLandSearchRoute(),
    },
    {
      title: "Terms and conditions",
      url: "/terms-and-conditions",
    },
    {
      title: "Privacy Policy",
      url: "/privacy-policy",
    },
    {
      title: "Contact us",
      url: "/contact-us",
    },
    {
      title: "Contact us",
      url: "/contact-us",
    },
  ];
};
